<template>
  <div id="Bubble_frame_id" class="frame-content">
    <div>
      <div id="prompt_Bubble" class="Prompt">
        <button class="Prompt__CloseButton" @click="$emit('promptClose')">
          close
        </button>
        <div class="Prompt__MessageBubble" @click="$emit('promptClicked')">
          <div class="Prompt__AvatarCustom"></div>
          <div class="Prompt__PromptText">
            Hi there, have a question? Text us here.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ChatWidgetPrompt",
  methods: {},
  emits: ["promptClose"],
};
</script>
